/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProductDetailBlockViewProps } from './product-detail-block';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { Node } from '@msdyn365-commerce-modules/utilities';

/*
const _renderImage = (imageUrl: string, imageAlt: string, width: number): JSX.Element => {
    if (imageUrl.includes('?')) {
        const index = imageUrl.indexOf('?');
        imageUrl = imageUrl.substring(0, index);
    }
    
    let dimensions;
    if (width >= 1008) {
        dimensions = '?w=400&h=400';
    } else if (width >= 641 && width <= 1007) {
        dimensions = '?w=280&h=280';
    } else {
        dimensions = '?w=200&h=200';
    }
    return <img src={`${imageUrl}${dimensions}`} alt={imageAlt} style={{maxWidth: 'none'}}/>;
};
*/

export default (props: IProductDetailBlockViewProps) => {
    const { MediaGalleryContainerProps, name, description, customClass } = props;
    /* let rendered;
    if (typeof window !== "undefined") {
        const [winDimensions, setWinDimensions] = React.useState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    
        React.useEffect(() => {
            function windowResize() {
                setWinDimensions({
                    height: window.innerHeight,
                    width: window.innerWidth
                })
            }
            window.addEventListener('resize', windowResize);
        }, []);
        rendered = _renderImage(imageUrl, imageAlt, winDimensions.width);
    } else {
        console.log("windows is undefined");
        rendered = _renderImage(imageUrl, imageAlt, 650);
    }*/

    return (
        <div className={`${customClass}` || 'details'}>
            <div className='row'>
                <div className="col-12">
                    <div className='img pull-left'>
                        <Node {...MediaGalleryContainerProps}>
                            {props.mediaGallery}
                        </Node>
                    </div>
                    <div className='text'>
                        <h1>{name}</h1>
                        <br />
                        <Msdyn365.RichTextComponent text={`<p>${description}</p>`} />
                    </div>
                </div>
            </div>
        </div>
    );
};
